module.exports = __webpack_public_path__ + "static/media/vaccine_slider_phone1.82af69df.png";